import React from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

function withRouter(Component) {
  return function ComponentWithRouterProp(props) {
    const navigate = useNavigate();
    const location = useLocation();
    const params = useParams();
    return (
      <Component
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...props}
        navigate={navigate}
        location={location}
        params={params}
      />
    );
  };
}
export default withRouter;
